import { api, unwrap, type ApiEnvelope } from './api';
import type { Client } from '@/types/client';

export interface ClientListResponse {
  items: Client[];
  total: number;
  page: number;
  pageSize: number;
}

export type ClientInput = Omit<Client, 'id' | 'createdAt' | 'updatedAt'>;

export async function listClients(params: { q?: string; page?: number; pageSize?: number } = {}): Promise<ClientListResponse> {
  return unwrap(api.get<ApiEnvelope<ClientListResponse>>('/clients', { params }));
}

export async function createClient(body: ClientInput): Promise<Client> {
  return unwrap(api.post<ApiEnvelope<Client>>('/clients', body));
}

export async function getClient(id: string): Promise<Client> {
  return unwrap(api.get<ApiEnvelope<Client>>(`/clients/${id}`));
}

export async function updateClient(id: string, patch: Partial<ClientInput>): Promise<Client> {
  return unwrap(api.patch<ApiEnvelope<Client>>(`/clients/${id}`, patch));
}

export async function deleteClient(id: string): Promise<void> {
  await api.delete(`/clients/${id}`);
}
